<template>
  <div class="row">
    <div class="col-3">
      <Search :onResponse="onResponse" immediate />
    </div>
    <div class="col-9">
      <Chart :chartdata="chartData" v-if="statistics?.length" />
      <Table :items="statistics" v-if="statistics?.length" name="Device" />
    </div>
  </div>
</template>

<script>
import Table from "../../components/statistics/Table";
import Search from "../../components/statistics/Devices/Search";
import Chart from "../../components/Chart";

export default {
  components: {
    Table,
    Search,
    Chart
  },
  data() {
    return {
      statistics: [],
    };
  },
  methods: {
    onResponse(stat) {
      this.statistics = stat;
    }
  },
  computed: {
    chartData() {
      let ret = {};
      this.statistics.forEach(element => {
        ret[element.name] = String(element.cnt);
      });
      return ret;
    }
  }
};
</script>

<style></style>
